module.exports = __webpack_public_path__ + "img/sii-icon.ef2b3518.svg";